<div class="logo-container">
    <img class="logo" [src]="logo" [class.icteam-logo]="this.isICTeam" />
    <h4 class="text" *ngIf="!this.isICTeam && !this.collapsed">{{org}}</h4>
</div>